var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageMyProfileIncompleteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3277 7.30531L25.6127 5.77331C24.3713 4.72251 22.9561 3.89645 21.4307 3.33231L20.7477 5.21031C22.0537 5.69474 23.2652 6.40437 24.3277 7.30531ZM28.3737 14.4453L30.3417 14.0323C30.0649 12.4346 29.5105 10.8978 28.7037 9.49131L26.9727 10.4453C27.6636 11.6893 28.1374 13.042 28.3737 14.4453ZM20.7477 27.6803L21.4307 29.5583C22.956 28.9945 24.3712 28.1688 25.6127 27.1183L24.3277 25.5863C23.2652 26.4873 22.0537 27.1959 20.7477 27.6803ZM26.9727 22.4453L28.7037 23.4453C29.5109 22.0226 30.0651 20.4705 30.3417 18.8583L28.3737 18.5113C28.1372 19.8937 27.6632 21.2246 26.9727 22.4453ZM16.5637 30.4453V2.44531C12.8506 2.44531 9.28967 3.92031 6.66416 6.54582C4.03866 9.17133 2.56366 12.7323 2.56366 16.4453C2.56366 20.1583 4.03866 23.7193 6.66416 26.3448C9.28967 28.9703 12.8506 30.4453 16.5637 30.4453Z",
    fill: "#EE1111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMyProfileIncompleteLogo);
export default __webpack_public_path__ + "static/media/manage_my_profile_incomplete_logo.5b964312e34473d46db56be67f207e8c.svg";
export { ForwardRef as ReactComponent };